import type { SVGProps } from 'react';
import React from 'react';

export const AddIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      fill="#458FFF"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00002 0.541748C7.3452 0.541748 7.62502 0.82157 7.62502 1.16675V6.37508H12.8334C13.1785 6.37508 13.4584 6.6549 13.4584 7.00008C13.4584 7.34526 13.1785 7.62508 12.8334 7.62508H7.62502V12.8334C7.62502 13.1786 7.3452 13.4584 7.00002 13.4584C6.65484 13.4584 6.37502 13.1786 6.37502 12.8334V7.62508H1.16669C0.821509 7.62508 0.541687 7.34526 0.541687 7.00008C0.541687 6.6549 0.821509 6.37508 1.16669 6.37508H6.37502V1.16675C6.37502 0.82157 6.65484 0.541748 7.00002 0.541748Z"
      />
    </svg>
  );
};